import React from 'react';

const loadSDK = (params, cb) => {
  ((d, w, id) => {
    if (!d.getElementById(id)) {
      const element = d.getElementsByTagName('script')[0];
      const s = d.createElement('script');
      s.id = id;
      s.async = 'async';
      s.src = 'https://cdn.freshbots.ai/assets/share/js/fbotsChat.min.js';
      s.setAttribute('data-region', params.region);
      s.setAttribute('data-prdct-hash', params.productId);
      s.setAttribute('data-ext-client-id', params.clientId);
      const onLoad = () => {
        window.history.onpushstate = () => {
          // Prevent reload chat
          const preventChat = true; /* eslint-disable-line */
        };
        if (cb) cb();
      };

      s.onreadystatechange = onLoad;
      s.onload = onLoad;
      element.parentNode.insertBefore(s, element);
    }
  })(document, window, 'spd-busns-spt');
};

type Props = {
  region?: string,
  clientId?: string,
  productId?: string,
};

type State = {};

/**
 * Freshbots Widget
 * @version 1.0.0
 * @author [Ubayd Rahmonzoda](ubayd.rahmonzoda@gmail.com)
 */
class FreshbotsWidget extends React.Component<Props, State> {
  static defaultProps = {
    region: 'us',
    productId: '72739a6abc259fc06bd3aae6d959178cf1ee37c7',
    clientId: '76393956ce5711e9990a0242ac110002',
  };

  componentDidMount() {
    const {
      region,
      clientId,
      productId,
    } = this.props;
    if (typeof window.Freshbots !== 'undefined') {
      window.Freshbots.activate();
    } else {
      loadSDK(
        {
          region,
          clientId,
          productId,
        },
        () => {
          console.log('loaded SDK');
        },
      );
    }
  }

  componentWillUnmount() {
    if (typeof window.Freshbots !== 'undefined') {
      window.Freshbots.deActivate();
    }
  }

  render() {
    return null;
  }
}

export default FreshbotsWidget;
